import { useDraggable } from "@dnd-kit/react";
import { ContentContainer } from "components/ui/display/ContentContainer";
import styled, { useTheme } from "styled-components";
import dragHandleUrl from 'assets/icons/drag_handle_300.svg';
import { Tag } from "components/ui/display/Tag";
import { useNavigate } from "react-router-dom";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectsListRow = ({project}) => {

    const { ref, handleRef } = useDraggable({id: project.projectUuid});

    const navigate = useNavigate();

    let latestUpdate = null;

    if(project.projectPhases.enabled)
    {
        latestUpdate = project.projectPhases.paths
                        .flatMap(path => path.pathUpdates)
                        .reduce((latest, current) => {
                            if(!latest) return current;
                            return new Date(current.date) > new Date(latest.date) ? current : latest;
                        }, null);
    }

    return (
        <StyledProjectsListRow
        ref={ref}
        paddingTop='sm'
        paddingBottom='sm'
        contentOrientation="row"
        contentGap="md"
        onDoubleClick={() => navigate('/projects/' + project.projectUuid)}
    >
            <div className="listDragHandle" ref={handleRef}>
                
            </div>
            <div className="listProjectNumber">
                <Tag text={project.projectNumber}/>
            </div>
            <div className="listProjectName">
                {project.projectName}
            </div>
            <div className="listProjectPhase">
                {project.projectPhases.enabled && project.projectPhases.mainPhase ? <Tag text={project.projectPhases.mainPhase}/> : null}
            </div>
            <div className="listProjectContent">
                {
                    project.projectContent.enabled ?
                        <>
                            {project.projectContent.road ? <Tag icon={<MaterialIcon name='road' weight={400}/>}/> : null}
                            {project.projectContent.sign ? <Tag icon={<MaterialIcon name='directions' weight={400}/>}/> : null}
                            {project.projectContent.signal ? <Tag icon={<MaterialIcon name='traffic' weight={400}/>}/> : null}
                            {project.projectContent.traffic ? <Tag icon={<MaterialIcon name='traffic_jam' weight={400}/>}/> : null}
                            {project.projectContent.safety ? <Tag icon={<MaterialIcon name='outdoor_garden' weight={400}/>}/> : null}
                            {project.projectContent.bim ? <Tag icon={<MaterialIcon name='brick' weight={400}/>}/> : null}
                            {project.projectContent.models3d ? <Tag icon={<MaterialIcon name='3d' weight={400}/>}/> : null}
                            {project.projectContent.document ? <Tag icon={<MaterialIcon name='draft' weight={400}/>}/> : null}
                        </>
                        : null
                }
            </div>
            <div className="listProjectUpdate">
                {latestUpdate ? latestUpdate.description : null}
            </div>
        </StyledProjectsListRow>
    )
}

const StyledProjectsListRow = styled(ContentContainer)`
    border-radius: 0;
    //border-top: none;
    margin-top: -1px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:last-child
    {
        border-bottom-left-radius: ${({theme}) => theme.cornerRadius.md};
        border-bottom-right-radius: ${({theme}) => theme.cornerRadius.md};
    }

    div.listDragHandle
    {
        background-image: url(${dragHandleUrl});
        background-position: top center;
        background-size: 110% auto;
        cursor: grab;
        flex: 0 0 15px;
        transition-duration: 110ms;
        display: flex;
        flex-direction: column;
        height: 25px;

        opacity: 0.25;

        &:hover
        {
            opacity: 0.5;
        }
    }

    div.listProjectNumber
    {
        width: 100px;
        flex: 0 0 100px;
    }

    div.listProjectName
    {
        flex: 1 0 0;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    div.listProjectUpdate
    {
        flex: 1 0 0;
        color: ${({theme}) => theme.colors.mutedForeground};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    div.listProjectPhase, div.listProjectContent
    {
        flex: 0.5 0 0;
        overflow: auto;
        display: flex;
        gap: ${({theme}) => theme.cornerRadius.sm};
    }
`

export const ProjectsEmptyListRow = () => 
{
    const GlobalTheme = useTheme();
    const color = encodeURIComponent(GlobalTheme.colors.mutedForeground);
    const backgroundBorderUrl = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='${color}' stroke-width='2' stroke-dasharray='10%2c 8' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e")`;

    return (
        <StyledProjectsEmptyListRow $borderImageUrl={backgroundBorderUrl}>
            Dra prosjektet over her.
        </StyledProjectsEmptyListRow>
    )
}

const StyledProjectsEmptyListRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${({theme}) => theme.spacing.md};
    color: ${({theme}) => theme.colors.mutedForeground};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    background-image: ${({$borderImageUrl}) => $borderImageUrl};
    user-select: none;
    text-align: center;
    padding: ${({theme}) => theme.spacing.md};
`